module.exports = __webpack_public_path__ + "static/media/go-arrow.8c429663.svg";